import React from 'react';
import Navbar from '../components/Navbar';
import Breadcrumb from '../components/Breadcrumb';
import HeroSectionSecondary from '../components/HeroSectionSecondary';
import { useEffect } from 'react';
import SnowfallEffect from '../components/SnowfallEffects';
import "../styles/snow.css"
import CTASection from '../components/CTASection';

const Snow = () => {
    useEffect(() => {
        const snowContainer = document.querySelector('.snow-overlay');
        if (snowContainer) {
          for (let i = 0; i < 50; i++) {
            const flake = document.createElement('div');
            flake.className = 'snowflake';
            flake.style.left = `${Math.random() * 100}%`;
            flake.style.animationDuration = `${4 + Math.random() * 4}s`;
            flake.style.opacity = Math.random().toFixed(2);
            flake.style.transform = `scale(${Math.random()})`;
            snowContainer.appendChild(flake);
          }
        }
      }, []);

  return (
    <div className="snow-page">
         <SnowfallEffect />
      <Navbar />
      <Breadcrumb />

      {/* Hero Section */}
      <div className="hero-with-snow" style={{ position: 'relative' }}>
        <div className="snow-overlay"></div>
        <HeroSectionSecondary
          title="Snow Removal"
          subtitle="Efficient, dependable snow and ice management services throughout Blaine County."
          button1Text="Request Consultation"
          button1Link="mailto:info@allseasons.info"
          target="_blank"
          rel="noopener noreferrer"
          button2Text="Gallery"
          button2Link="/gallery/snow"
          image="/images/snowHeroImage.png"
        />
      </div>

      {/* Section One: The All Seasons Approach */}
      <section className="section snow-approach">
        <div className="section-inner">
          <h2 className="section-title">THE ALL SEASONS APPROACH</h2>
          <p className="approach-text">
            We stay ahead, act fast, and stay ready all season long. Our team monitors storms, manages routes, and clears properties with precision; keeping driveways, roads, and access points safe and open no matter the weather.
          </p>
        </div>
      </section>

      {/* Section Two: Service Capabilities */}
      <section className="section snow-capabilities">
        <div className="section-inner">
          <h2 className="section-title">OUR SERVICE CAPABILITIES</h2>

          <div className="capabilities-grid">
            <div className="capability-card">
              <div className="capability-number">01</div>
              <h3>Residential & Commercial Snow Removal</h3>
              <p>From private homes to large commercial sites, we provide dependable plowing, hand shoveling and snow hauling customized to each property's needs.</p>
            </div>

            <div className="capability-card">
              <div className="capability-number">02</div>
              <h3>Community & HOA Access</h3>
              <p>Our crews maintain neighborhood roads and shared access points for consistent safety and reliability all season long.</p>
            </div>

            <div className="capability-card">
              <div className="capability-number">03</div>
              <h3>Roof Snow Removal</h3>
              <p>Our staff is trained in roof clearing using full safety equipment. A signed damage waiver is required for all roof work.</p>
            </div>

            <div className="capability-card">
              <div className="capability-number">04</div>
              <h3>24/7 Emergency Response</h3>
              <p>When the weather turns fast, we're on call. Our team provides around-the-clock response for snow, ice, and access emergencies across Blaine County.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Section Three: Why All Seasons */}
      <section className="section snow-why">
        <div className="section-inner">
          <h2 className="section-title">WHY ALL SEASONS</h2>
          <p className="why-text">
            We take pride in doing the job right the first time. It's a standard that guides every crew, every storm, and every property we serve across the Wood River Valley — because that's how trust is built, and how it's kept, season after season.
          </p>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection
        title="Winter Happens. We're Ready."
        subtitle="Join hundreds of satisfied customers who trust All Seasons for dependable snow and ice management services."
        galleryLink="/Gallery/snow"
        showEmergency={true}
      />
    </div>
  );
};

export default Snow;
